import { ArticleMeta } from 'types/blog';

// ==============================|| 記事のメタ ||============================== //
//
// 一覧・カテゴリ一覧・関連記事のカードは、このファイルだけを読む。
// 本文(同名の .ts)と分けているのは、一覧を描くのに全記事の本文まで
// JSバンドルへ入れないため(詳しくは src/const/blog/registry.ts)。
//
// ★ ここに本文を書かないこと。書いた瞬間、一覧がそれを読み込むようになる。

export const meta: ArticleMeta = {
    slug: 'jouhou-kouhyou-mihoukoku-gensan',
    title: '情報公表未報告減算｜5%減の要件と都道府県への報告時期',
    description:
        '情報公表未報告減算は5%減。虐待防止措置やBCPの1%減より率が大きいのに、名前だけしか知られていません。障害福祉サービス等情報公表システムからの報告の時期、都道府県の指導を受けてなお報告しない場合という要件、年1回の更新を落とさないための段取りを、共通Q&Aの原文つきで整理しました。',
    excerpt:
        '1%減の減算は覚えていても、5%減のこの減算は抜けがちです。会計年度が終わったあとの情報公表システムの更新、誰が担当するか決まっていますか。',
    category: '運営指導',
    keywords: [
        '情報公表未報告減算',
        '障害福祉サービス等情報公表システム',
        '情報公表 未報告 減算',
        '情報公表システム 報告 いつ',
        'WAMNET 障害福祉 情報公表'
    ],
    publishedAt: '2026-07-22',
    updatedAt: '2026-07-22',
};
